var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibility && _vm.speech)?_c('v-card',{staticClass:"avatar-speech",attrs:{"color":"transparent","flat":""}},[_vm._v(" "+_vm._s(_vm.speech)+" "),_c('v-img',{staticClass:"play-btn",attrs:{"src":require('@/assets/images/playBtn.png')},on:{"click":_vm.play}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }